import {DxOperationResultType} from "../../../dx-core/domain/common/dx-operation-result-type";
import {DxAppError} from "../../../dx-core/domain/error/dx-app-error";

export class DxSessionRefreshResult {
  private _type: DxOperationResultType;

  /** Причина проваленного обновления сессии. **/
  private _error: DxAppError;

  get type(): DxOperationResultType {
    return this._type;
  }

  set type(value: DxOperationResultType) {
    this._type = value;
  }

  get error(): DxAppError {
    return this._error;
  }

  set error(value: DxAppError) {
    this._error = value;
  }
}
